<template>
  <div class="care-detail" :type="type">
    <!-- <div class="care-head-info" v-if="care && care.audit === 30">
      <img src="../../assets/login-fail.png" />
      <div>
        <div class="name">激活失败</div>
        <div class="info">{{ care.auditFailReason }}</div>
      </div>
    </div> -->
    <div>
      <care-card
        size="big"
        class="card"
        :care="care"
      ></care-card>
    </div>
    <template v-if="service && service.length > 0">
      <div class="service-title">
        <div>尊享<span> {{ ((service && service.length) || "0") }} </span>大权益</div>
        <div v-if="serviceExplain"
                class="service-explain"
                @click="showServiceExplain = true"
        >
          查看更多权益 &gt;
        </div>
      </div>
      <div class="process-layout module">
        <div
          class="process"
          v-for="(item, index) in service"
          :key="'service-p-' + index"
        >
          <div class="service-head">
            <div class="ico"><span><img :src="item.icon"/></span></div>
            <div class="name">
              <span>{{ item.name }}</span>
              <template v-if="care.status != 10">
                <span v-if="item.time" class="time">
                {{ !item.valid?'失效时间：':" 有效期至" }}{{item.time}}
              </span>
              </template>
            </div>
            <div class="fill"></div>
            <template v-if="item.HasRepaireOrder">
              <div class="use-info invaild">
                服务中
              </div>
            </template>
            <template v-else>
              <div v-if="item.valid" class="use-info">
                <template v-if="isNaN(item.info)">
                  <span v-if="care.status == 10">激活后</span>
                  <span v-if="care.status == 10">生效</span>
                  <span v-if="care.status !== 10" class="invaild">{{item.info}}</span>
                </template>
                <template v-else>
                  <span v-if="care.status == 10">激活后</span>
                  <span v-if="care.status == 10">可用：{{ item.info }}{{item.unit}}</span>
                  <span v-if="care.status !== 10" class="num">{{ item.info }}</span>
                  <span v-if="care.status !== 10">可使用({{item.unit}})</span>
                </template>
              </div>
              <div class="invaild use-info" v-else>{{care.status == 100?'已使用':item.use >= item.total?'已使用': '已失效'}}</div>
            </template>
          </div>
        </div>
      </div>
    </template>
    <div v-if="service" class="more-info module">
      <template v-if="hasRecord"><!--审核中无服务记录-->
        <div @click="goRecord">服务订单</div>
        <div class="divider"></div>
      </template>
     <!-- <div @click="goStore">附近服务门店 <span class="sub">如需到店享受服务<br>请先联系400-088-9898预约</span></div>-->
        <!--<div class="divider"></div>-->
      <div v-if="isWechat && wxCardId && ShowCareBar" @click="addToWechat">添加至微信卡包</div>
      <div v-if="isWechat && wxCardId" class="divider"></div>
      <div @click="goAgreement">查看详细服务条款</div>
    </div>
    <div class="bottom">
      <div class="msg" v-if="auditing">客服正在处理您的无忧卡激活，请耐心等待</div>
      <div class="con">
        <a class="service-call" href="javascript:void(0)" @click="goto('KF_SERVICE')">
          <span><img src="../../assets/service-call.png" alt="service call" /></span>
          <span>客服</span>
        </a>
        <y-button v-if="enable" class="btn" @click="onCardClick()">{{buttonText}}</y-button>
        <y-button v-else class="btn" disabled>{{buttonText}}</y-button>
      </div>
    </div>
    <van-dialog v-model="showServiceExplain">
      <p class="service-explain-dialog" v-html="serviceExplain"></p>
    </van-dialog>
    <y-apply-card-service v-model="showApplyService" :cardId="id" :service="service" :cardInfo="care"></y-apply-card-service>
    <van-dialog class="new-year-dialog" v-model="holiday" confirm-button-text=" ">
      <div class="con">
        <p>尊敬的用户：</p>
        <p>
          由于春节假期将至，无忧卡将在<span>2024年2月6日2024年2月17日</span>期间暂停在线履约申请受理，<span>2024年2月18日</span>恢复申请受理。若您此期间有效期到期，且产生履约需求，可在2月18日恢复服务后7日内拨打4000889898客服电话继续申请履约。
        </p>
        <p>给您带来不便，敬请谅解！</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog } from "vant";
import { httpOpen } from "../../scripts/network";
import { login } from "../../scripts/auth";
const { wechatCardId } = process.env.CONFIG
Vue.use(Dialog);

export default {
  name: "CareDetail",
  data() {
    return {
        id: "",
        type: 10,
        care: null,
        code: "",
        isWechat: this.$store.state.isWechat,
        wxCardId: wechatCardId,
        serviceBase: {
          "1": {
            name: "免费贴膜",
            icon: require("../../assets/ic_sticker.png"),
            type: 1,
            use: 0,
            total: 0,
            unit: "次",
          },
          "2": {
            name: "电池更换",
            icon: require("../../assets/ic_battery.png"),
            type: 2,
            use: 0,
            total: 0,
            unit: "次",
          },
          "3": {
            name: "屏幕更换",
            icon: require("../../assets/ic_screen.png"),
            type: 3,
            use: 2,
            total: 0,
            unit: "次",
          },
          "4": {
            name: "整机质保",
            icon: require("../../assets/ic_insurance.png"),
            type: 4,
            use: 0,
            total: 0,
            unit: "年",
            info: "保护中",
          },
            "5": {
                name: "后壳更换",
                icon: require("../../assets/card-qy-type-5.png"),
                type: 5,
                use: 0,
                total: 0,
                unit: "次"
            },
        },
        service: [],
        serviceExplain: null,
        showServiceExplain: false,
        codeSupport: [1],
        formSupport: [2, 3, 4],
        showApplyService:false,
        holiday: false
    };
  },
  computed: {
	ShowCareBar: function(){
	    return this.$store.state.ShowCareBar;
	},
    hasRecord: function(){
      return this.care && this.care.status != 10;
    },
    auditing: function(){
      return this.care && this.care.status == 10 && this.care.audit == 10;// 激活审核中
    },
    enable: function(){
      // 已激活||未提交激活||激活失败
      return this.care && (this.care.status == 20 || (this.care.status == 10 && this.care.audit != 10));
    },
    buttonText: function(){
      let txt = "申请服务";
      if(this.care && this.care.status == 10){
        if(this.care.audit == -1){
          txt = "立即激活"; // 未提交激活
        }else if(this.care.audit == 30) {
          txt = "重新激活"; // 激活失败
        }
      }
      return txt;
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.loadDetail();
  },
  methods: {
    filterService(service, type) {
      return service.filter(
        (element) => element.supportTypes.findIndex((t) => t === type) !== -1
      );
    },
    async loadDetail() {
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/GetCardInfo", {
          type: "post",
          body: { CardSysNo: this.id },
        });
        if (ret.Status) {
          this.care = this.careCardResultMapper(ret.Data);
          this.type = ret.Data.ServiceType;
          this.code = ret.Data.ActivationCode;
          // this.wxCardId = ret.Data.WxCardId;
          this.service = ret.Data.OrderEquityList.map(this.serviceMapper);
          this.serviceExplain = ret.Data.ServiceExplain;
        }
        else {
          this.$toast(ret.Message || '加载失败');
        }
        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    serviceMapper(item) {
      let service = this.serviceBase[item.EquityType];
      if(!service) {
        service = { name:item.EquityTypeName, unit:'次' };
      }
      service.HasRepaireOrder = item.HasRepaireOrder;
      service.type = item.EquityType;
      service.use = item.UseTotalNum;
      service.total = item.EquityTotalCount;
      service.time = item.FailureTime &&
        new Date(item.FailureTime + "+08:00").format("yyyy-MM-dd"); //主卡有失效时间,权益项才会有失效时间
      service.valid = service.type == 4?service.use == -1:service.use > -1 && service.use < service.total;
      service.info =
        service.info || `${service.total - service.use}`;
      return service;
    },
    careCardResultMapper(data) {
      return {
        id: data.SysNo,
        type: data.ServiceType,
        endTime: data.FailureTime && new Date(data.FailureTime + "+08:00"),
        name: data.ServiceTypeName,
        imei: data.IMEICode,
        status: data.CardStatus,
        audit: data.AuditStatus,
        auditFailReason: data.AuditFailReason,
        effectiveDay: data.EffectiveDay,
        img: data.CardLogo,
        canRenew: data.IsSupportRenew == 1 && data.CardStatus == 20, // 当前是否可以续费(卡已激活 && 可续费卡)
      };
    },
    onCardClick() {
      if (this.care.status === 20) {
        // 休假公告
        this.holiday = new Date(new Date().toGMTString())  >=new Date("2024/02/05 18:00:00+08:00") && new Date(new Date().toGMTString()) <=new Date("2024/02/18 00:00:00+08:00") &&!window.session.getValue("holiday-notice");

        if (this.holiday) {
          window.session.saveValue("holiday-notice", 1);
        } else {
            this.applyForService()
        }
      } else if (this.care.audit === 30 || this.care.audit === -1) {
        this.goActive();
      }
    },
    goActive() {
      this.$router.push({
        name: "CareActive",
        params: {
          code: this.code,
          type: this.type
        },
        query: {
          name: this.care.name
        }
      });
    },
    async addToWechat() {
      this.$loading.show("");
      const ret =  await this.addWechatCard(this.wxCardId);
      this.$loading.hide();
      if(ret === 401){
         login(this.$store, this.$router);
      }
    },
    applyForService() {
      const params = {
        id: this.id,
        type: this.type,
        service: this.service.map((item) => {
          return { type: item.type, use: item.use, total: item.total };
        }),
      };
      if (this.service && this.service.length > 1) {
        this.showApplyService = true;
      } else if (this.service && this.service.length === 1) {
        const service = this.service[0];
        const serviceType = service.type;
        if (service.total <= service.use) {
          this.goto(`/care/${this.id}/service/none`);
          return;
        }
        if (this.codeSupport.findIndex((item) => item === serviceType) >= 0) {
          this.$router.push({
            name: "ServiceCode",
            params: params,
          });
        } else if (
          this.formSupport.findIndex((item) => item === serviceType) >= 0
        ) {
          this.$router.push({
            name: "ServiceForm",
            params: params,
          });
        }
      }
    },
    goRecord() {
      this.$router.push({
        name: "OrderRecord",
        params: {
          id: this.id,
        },
      });
    },
    goStore() {
      this.goto(process.env.CONFIG.storeAddress);
    },
    async goAgreement() {
      this.goto(`/agreement?code=${this.code}`);
    }
  },
};
</script>

<style lang="less" scoped>
.care-detail {
  padding: 16px 16px 130px 16px;
  min-height: 100vh;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 500;
  background: #f4f4f4;
  .module{
    background-color: #fff;
    border-radius: 8px;
  }
  .fill {
    flex: 1 1;
  }
  .care-head-info {
    padding: 24px;
    color: white;
    display: flex;
    flex-direction: row;
    img {
      display: block;
      width: 64px;
      margin-right: 8px;
    }
    .name {
      font-size: 16px;
      font-weight: bold;
    }
    .info {
      font-size: 14px;
      font-weight: 500;
      color: #cccccc;
    }
  }

  .service-title {
    color: #2E2E2E;
    font-size: 16px;
    margin: 23px 0 0 8px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    span {
      color: #DE4E4A;
    }
    .service-explain {
      font-weight: 400;
      color: #333;
      text-align: center;
      font-size: 14px;
    }
  }
  .service-layout {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 16px;
    min-height: 60px;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      * + * {
        margin-top: 4px;
      }
      img {
        width: 22px;
        height: 30px;
      }
      .name {
        color: white;
      }
      .total {
        color: #e6c587;
      }
    }
  }
  .single-service-info {
    display: flex;
    align-items: center;
    margin: 20px 0;
    font-size: 14px;
    padding: 0 10px;
    img {
      width: 20px;
      padding-right: 4px;
    }
    .name {
      color: white;
    }
    .info {
      color: white;
      flex: 1 1;
      text-align: right;
    }
  }
  .process-layout {
    font-size: 14px;
    margin-top: 11px;
    .process{
      &:not(:last-child){
        border-bottom: 1px solid #efefef;
      }
    }
    .service-head {
      padding: 15px 18px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      color: #faddaf;
      align-items: center;
      .ico{
        margin-right: 22px;
        >span{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 36px;
          height: 36px;
          border-radius: 100%;
          background: linear-gradient(325deg,rgba(50,50,50,0.84) 8%, rgba(0,0,0,0.84) 92%);
          text-align: center;
          img{
            width: 15px;
            height: 20px;
          }
        }
      }
      .name{
        display: flex;
        flex-direction: column;
        font-weight: 600;
        color: #000000;
        font-size: 14px;
        .time {
          font-size: 12px;
          color: #333;
          font-weight: normal;
        }
      }
      .use-info {
        color: #8D6D41;
        display: flex;
        flex-direction: column;
        text-align: right;
        .num{
          font-weight: 600;
          font-size: 18px;
        }
      }
      .invaild {
        color: #ff8f8f;
      }
    }
    .van-progress {
      background: #414458;
    }
  }
  .more-info {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    margin-top: 16px;
    font-size: 15px;
    color: #000;
    div {
      height: 50px;
      line-height: 50px;
      position: relative;
    }
    .sub{
      position: absolute;
      font-size: 12px;
      line-height: 16px;
      right: 0;
      top: 12px;
      color: #666;
    }
    .divider {
      width: 100%;
      height: 1px;
      background-color: #efefef;
      transform: scaleY(1);
    }
  }
  .bottom{
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    .msg{
      background-color: #FFF7EB;
      padding: 9px 0;
      text-align: center;
      font-size: 14px;
      color: #4d3621;
    }
    .con{
      padding: 7px 23px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .service-call {
        display: flex;
        width: 54px;
        height: 54px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #4F4F4F;
        padding: 0 10px;
        img {
          width: 17px;
          height: 18px;
        }
      }
      .btn{
        flex: 1 1;
      }
    }
  }
  &[type="10"] {
    .service-layout {
      .item {
        .total {
          color: #cce1f4;
        }
      }
    }
    .process-layout {
      .service-head {
        color: #cce1f4;
      }
      .process {
        .van-progress__portion {
          background: linear-gradient(to right, #c7ddf1, #a2bddb) !important;
        }
      }
    }
  }
  &[type="20"] {
    .service-layout {
      .item {
        .total {
          color: #faddaf;
        }
      }
    }
    .process-layout {
      .service-head {
        color: #faddaf;
      }
      .process {
        .van-progress__portion {
          background: linear-gradient(to right, #eed6a7, #e4c181) !important;
        }
      }
    }
  }
  .service-explain-dialog {
    white-space: pre;
    margin: 16px;
    color: black;
    line-height: 28px;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
  }
  .new-year-dialog{
    background: url("~@/assets/notice-new-year-bg.png") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    overflow: initial;
    font-size: 14px;
    padding: 0 30px;
    box-sizing: border-box;
    border-radius: inherit;
    &:before{
      content: '';
      position: absolute;
      background: url("~@/assets/notice-new-year-1.png") 0 0 no-repeat;
      background-size: 100%;
      top:-50px;
      left: 30px;
      right: 30px;
      height: 200px;
    }
    .con{
      padding: 60px 0 20px 0;
      line-height: 1.7;
      p{
        margin: 10px 0;
      }
      span{
        color: #FFEFA4;
      }
    }
  }
}
</style>
<style scoped>
  .new-year-dialog >>>.van-dialog__footer{
    position: absolute;
    left: 20%;
    right: 20%;
    bottom:-68px;
  }
  .new-year-dialog >>>.van-dialog__footer .van-button{
    background: url("~@/assets/notice-new-year-2.png") 50% 50% no-repeat;
    background-size: 80%;
  }
  .new-year-dialog >>>.van-dialog__footer .van-button:before{
    background-color: initial;
    border: none;
  }
  .new-year-dialog >>>.van-dialog__footer:after{
    background-color: initial;
    border: none;
  }
</style>
